import clsx from 'clsx';
import type * as React from 'react';

import { type IconDefinition, renderIcon } from '@gitbook/spine-react';

/**
 * Minimalist blankslate to show a message instead of a drawing.
 */
export function DrawingGenericBlankslate(props: {
    kind?: 'default' | 'danger';
    message: string;
    icon: IconDefinition;
    children?: React.ReactNode;
}): React.ReactElement {
    const { icon, message, kind = 'default', children } = props;

    return (
        <div className="flex flex-col items-center justify-center rounded-sm border-2 border-dashed p-6">
            {renderIcon(icon, {
                size: 24,
                className: clsx(kind === 'danger' ? 'text-danger' : 'text-light'),
            })}
            <div
                className={clsx(
                    'mt-4 text-center text-content-paragraph',
                    kind === 'danger' ? 'text-danger' : 'text-light'
                )}
            >
                {message}
            </div>
            {children ? (
                <div className="mt-4 flex w-full flex-col items-center">{children}</div>
            ) : null}
        </div>
    );
}
